import React, { useEffect, useRef } from 'react';

// useEffect, ale bez początkowej inicjalizacji

export default (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};
